import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let END_POINT

if (window.location.protocol === 'http:') {
    END_POINT = `http://localhost:5001`
}
else {
    END_POINT = `https://${window.location.host}/api`
}

// jwtToken
const getJwtToken = () => {
    const userData = JSON.parse(localStorage.getItem("clinic-application-jwt"));
    return "Bearer " + String(userData.token);
};


export const getAllAilments = createAsyncThunk(
  "Ailments/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${END_POINT}/subAilments/main-services`, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      // console.log(res.data);
      return res.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // ✅ No items, return empty array instead of rejecting
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
